export default __webpack_public_path__ + "static/media/housemaid.e06a3d48.jpg";